import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap, catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const jwtInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  if (req.url.startsWith('/assets/')) return next(req);

  const auth = inject(AuthService);

  return from(auth.getToken()).pipe(
    switchMap(token => {
      if (token) {
        req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
      }
      return next(req).pipe(
        catchError(error => {
          if (error instanceof HttpErrorResponse && error.status === 401 && !req.url.includes('/auth/')) {
            return from(auth.refresh()).pipe(
              switchMap(newToken => {
                if (newToken) {
                  const retried = req.clone({ setHeaders: { Authorization: `Bearer ${newToken}` } });
                  return next(retried);
                }
                return from(auth.logout()).pipe(
                  switchMap(() => throwError(() => error))
                );
              })
            );
          }
          return throwError(() => error);
        })
      );
    })
  );
};
